Vue.component('monthly-date-range-select', {
    data: function () {
        return{
            selected: 0,
            dates: []
        }
    },
    created: function () {
        this.dates = this.generateMonths();
        this.$emit('input', this.dates[this.selected]);
    },
    methods: {
        generateMonths: function () {
            var dates = []
            for (var i = 0; i < 13; i++) {
                var date = this.getMonthDays(i);
                dates.push(date);
            }
            return dates;
        },
        getMonthDays: function (month) {
            var today = new Date();

            var date = new Date(today.getFullYear(), today.getMonth() + month, 1)

            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            if (today.getTime() > firstDay.getTime()){
                firstDay = today;
            }

            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            return {
                first: firstDay,
                last: lastDay,
                text: this.getMonthName(date.getMonth()) + " " + date.getFullYear()
            }
        },
        getMonthName: function (month) {
            var key = 'js.month.name.' + month;
            return FmtMessage.getMessage(key) ? FmtMessage.getMessage(key) : key;
        },
        dateChange: function () {
            this.$emit('input', this.dates[this.selected]);
        }
    },
    template: '<select v-model="selected" @change="dateChange" class="form-control">\
                <option v-for="(date, index) in dates" :value="index" :key="date.text" :selected="index == 0">{{date.text}}</option>\
               </select>'
});

